import { cn } from '@/utils'

export const container = cn(
	'mx-auto px-3 mobile:px-5 tablet:px-8 desktop:max-w-[min(1216px,calc(100%-64px))] desktop:px-0',
)

export const grid = cn(
	'grid grid-cols-4 gap-x-5 desktop:grid-cols-12 desktop:gap-x-8',
)

export const card = cn('rounded-10 bg-white p-6 shadow-generator')

export const layoutTopSafePadding = cn(
	'[header.fixed~&]:pt-16 desktop:[header.fixed~&]:pt-18 [header.fixed~div>&]:pt-16 desktop:[header.fixed~div>&]:pt-18',
)
